import { useStore } from ".";
interface ActionCreatorFn<Input> {
	(param: Input): { type: string; payload: any };
}
export const useActionCreator = <Input>(creator: ActionCreatorFn<Input>) => {
	const [, dispatch] = useStore();
	return (arg: Input) => dispatch(creator(arg));
};
